import CssBaseline from "@material-ui/core/CssBaseline"
import Link from "@material-ui/core/Link"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import React from "react"

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary">
      {"© "}
      <Link href="https://conservationxlabs.com/">Conservation X Labs</Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
  footer: {
    marginTop: "auto",
  },
}))

export default function StickyFooter() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <CssBaseline />
      <footer className={classes.footer}>
        {/* <Typography variant="body1"></Typography> */}
        <Copyright />
      </footer>
    </div>
  )
}
